/*

Author: David Biga - All rights reserved - 2015

Description:  This is the core file that handles our room type based on the gui selected model

NOTE:  It is VERY important we decrease everything by 1 point and we still acumulate everything by 25.  Reason be, pretend there is a invisible in that last point.

*/
import THREE from 'particlespace-graphics-engine'

import {colorCoding} from '../../../core/controllers/ColorCoding'
import {sensorRenderer} from '../controllers/SensorRenderer'

// handles our rendering of all of our objects
var RoomRenderer = Class.create({
  	initialize: function() {
		// setup our local vars
		// #  Load colors
		this.loadColors();
		// default is single room type
		var cubeGeometry = new THREE.BoxGeometry( 49, 50, 49,1,1,1 );// moving to roomObj
		var cubeMaterial = new THREE.MeshLambertMaterial( { color: this.colorNormal, overdraw: 1} ); // moving to roomObj
		var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: this.colorNormal, transparent: true, opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj
		var divideScalar = 50; 
		var multiplyScalar = 50;
		var addScalar = 25;
		
		var additionalZ = 0;
		var additionalX = 0;
		this.additionalZ = additionalZ;
		this.additionalX = additionalX;
		
		this.roomID = 1;
		this.roomType = 'onebysingleRoom';
		this.size = 49
		
		this.divideScalar = divideScalar;
		this.multiplyScalar = multiplyScalar;
		this.addScalar = addScalar;
		this.cubeGeometry = cubeGeometry;
		this.cubeMaterial = cubeMaterial;
		this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		this.isActive = false;

		this.updateRoomType('twobytwoRoom');
  	},
	updateRoomType: function(domID)
	{
		sensorRenderer.isActive = false;
		this.isActive = true;
		if(domID == 'onebysingleRoom')
		{
			var cubeGeometry = new THREE.BoxGeometry( 49, 50, 49,1,1,1 );// moving to roomObj
			var cubeMaterial = new THREE.MeshLambertMaterial( { color: this.colorNormal, overdraw: 1 } ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: this.colorNormal, transparent: true, overdraw: 0,opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj
			var divideScalar = 50; 
			var multiplyScalar = 50;
			var addScalar = 25;
			
			var additionalZ = 0;
			var additionalX = 0;
			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			
			/*var colorNormal = 0x00ff80;
			var colorHover = 0xE4E4E4;
			var colorTmpHover = 0xEAEAEA;
			var colorRemove = 0xE23434;
			
			this.colorNormal = colorNormal;
			this.colorHover = colorHover;
			this.colorTmpHover = colorTmpHover;
			this.colorRemove = colorRemove;*/
		
			this.roomID = 1;
			this.roomType = 'onebysingleRoom';
			this.size = 49
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		}
		else if(domID == 'onebytwoRoom')
		{
			var cubeGeometry = new THREE.BoxGeometry( 49, 50, 99,1,1,2 );// moving to roomObj
			var cubeMaterial = new THREE.MeshLambertMaterial( { color: this.colorNormal, overdraw: 1 } ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: this.colorNormal, transparent: true, overdraw: 0, opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj
			var divideScalar = 50; 
			var multiplyScalar = 50;
			var addScalar = 25;
		
			var additionalZ = 0;
			var additionalX = 0;
			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			
			/*var colorNormal = 0x00ff80;
			var colorHover = 0xE4E4E4;
			var colorTmpHover = 0xEAEAEA;
			var colorRemove = 0xE23434;
			
			this.colorNormal = colorNormal;
			this.colorHover = colorHover;
			this.colorTmpHover = colorTmpHover;
			this.colorRemove = colorRemove;*/
		
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;
			this.roomID = 2;
			this.roomType = "onebytwoRoom";
			this.size = 50
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		}
		else if(domID == 'onebytripleRoom')
		{
			var cubeGeometry = new THREE.BoxGeometry( 49, 50, 149,1,1,3 );// moving to roomObj
			var cubeMaterial = new THREE.MeshLambertMaterial( { color: this.colorNormal,overdraw: 1 } ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: this.colorNormal, transparent: true, overdraw: 0, opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj
			var divideScalar = 50; 
			var multiplyScalar = 50;
			var addScalar = 25;
		
			var additionalZ = 0;
			var additionalX = 0;
			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			
			/*var colorNormal = 0x00ff80;
			var colorHover = 0xE4E4E4;
			var colorTmpHover = 0xEAEAEA;
			var colorRemove = 0xE23434;
			
			this.colorNormal = colorNormal;
			this.colorHover = colorHover;
			this.colorTmpHover = colorTmpHover;
			this.colorRemove = colorRemove;*/
		
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;
			
			this.roomID = 3;
			this.roomType = 'onebytripleRoom';
			this.size = 150
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		}
		else if(domID == 'twobytwoRoom')
		{
			var cubeGeometry = new THREE.BoxGeometry( 99, 50, 99,2,1,2 );// moving to roomObj
			var cubeMaterial = new THREE.MeshLambertMaterial( { color: this.colorNormal,overdraw: 1 } ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: this.colorNormal, transparent: true, overdraw: 0, opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj
			var divideScalar = 50; 
			var multiplyScalar = 50;
			var addScalar = 25;
			var additionalZ = 25;
			var additionalX = 25;
			
		
		
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;
			
			/*var colorNormal = 0x00ff80;
			var colorHover = 0xE4E4E4;
			var colorTmpHover = 0xEAEAEA;
			var colorRemove = 0xE23434;
			
			this.colorNormal = colorNormal;
			this.colorHover = colorHover;
			this.colorTmpHover = colorTmpHover;
			this.colorRemove = colorRemove;*/
		
			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			this.roomID = 4;
			this.roomType = 'twobytwoRoom';
			this.size = 99
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		}
		else if(domID == 'twobythreeRoom')
		{
			var cubeGeometry = new THREE.BoxGeometry( 99, 50, 149,2,1,3 );// moving to roomObj
			var cubeMaterial = new THREE.MeshLambertMaterial( { color: this.colorNormal,overdraw: 1 } ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: this.colorNormal, transparent: true, overdraw: 0, opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj
			var divideScalar = 50; 
			var multiplyScalar = 50;
			var addScalar = 25;
		
			var additionalZ = 0;
			var additionalX = 25;
			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			
			/*var colorNormal = 0x00ff80;
			var colorHover = 0xE4E4E4;
			var colorTmpHover = 0xEAEAEA;
			var colorRemove = 0xE23434;
			
			this.colorNormal = colorNormal;
			this.colorHover = colorHover;
			this.colorTmpHover = colorTmpHover;
			this.colorRemove = colorRemove;*/
		
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;
			
			this.roomID = 5;
			this.roomType = 'twobythreeRoom';
			this.size = 149
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		}
		else if(domID == 'twobyfourRoom')
		{
			var cubeGeometry = new THREE.BoxGeometry( 99, 50, 199,2,1,4 );// moving to roomObj
			var cubeMaterial = new THREE.MeshLambertMaterial( { color: this.colorNormal,overdraw: 1 } ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: this.colorNormal, transparent: true, overdraw: 0, opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj
			var divideScalar = 50; 
			var multiplyScalar = 50;
			var addScalar = 25;
			
			var additionalZ = 25;
			var additionalX = 25;
			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
		
			/*var colorNormal = 0x00ff80;
			var colorHover = 0xE4E4E4;
			var colorTmpHover = 0xEAEAEA;
			var colorRemove = 0xE23434;
			
			this.colorNormal = colorNormal;
			this.colorHover = colorHover;
			this.colorTmpHover = colorTmpHover;
			this.colorRemove = colorRemove;*/
		
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;
			
			this.roomID = 6;
			this.roomType = 'twobyfourRoom';
			this.size = 199
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		}
		else if(domID == 'onebyonehall')
		{
			var cubeGeometry = new THREE.BoxGeometry( 50, 0, 50 );// moving to roomObj
			var cubeMaterial = new THREE.MeshLambertMaterial( { color: this.colorNormal, overdraw: 1 } ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: this.colorNormal, transparent: true, overdraw: 0,opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj
			var divideScalar = 25; 
			var multiplyScalar = 25;
			var addScalar = 0;
			
			var additionalZ = 0;
			var additionalX = 0;
			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			
			/*var colorNormal = 0x949494;
			var colorHover = 0xEAEAEA;
			var colorTmpHover = 0xEAEAEA;
			var colorRemove = 0xE23434;
			
			this.colorNormal = colorNormal;
			this.colorHover = colorHover;
			this.colorTmpHover = colorTmpHover;
			this.colorRemove = colorRemove;*/
		
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;
			
			this.roomID = 7;
			this.roomType = 'onebyonehall';
			this.size = 50
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		}
		else if(domID == 'twobytwohall')
		{
			var cubeGeometry = new THREE.BoxGeometry( 100, 0, 50 );// moving to roomObj
			var cubeMaterial = new THREE.MeshLambertMaterial( { color: this.colorNormal, overdraw: 1 } ); // moving to roomObj
			var cubeTmpHoverMaterial = new THREE.MeshLambertMaterial({ color: this.colorNormal, transparent: true, overdraw: 0,opacity:0.5});// used to give a transparency to the cube tmp view // moving to roomObj
			var divideScalar = 25; 
			var multiplyScalar = 25;
			var addScalar = 0;
		
			var additionalZ = 0;
			var additionalX = 0;
			this.additionalZ = additionalZ;
			this.additionalX = additionalX;
			
			/*var colorNormal = 0x949494;
			var colorHover = 0xEAEAEA;
			var colorTmpHover = 0xEAEAEA;
			var colorRemove = 0xE23434;
			
			this.colorNormal = colorNormal;
			this.colorHover = colorHover;
			this.colorTmpHover = colorTmpHover;
			this.colorRemove = colorRemove;*/
			
			this.divideScalar = divideScalar;
			this.multiplyScalar = multiplyScalar;
			this.addScalar = addScalar;
			
			this.roomID = 8;
			this.roomType = 'twobytwohall';
			this.size = 50
			this.cubeGeometry = cubeGeometry;
			this.cubeMaterial = cubeMaterial;
			this.cubeTmpHoverMaterial = cubeTmpHoverMaterial;
		}
	},
	// #  Gets our geometry based on abbreviation type
	getGeometry: function(domID)
	{
		var cubeGeometry;

		if(domID == 'onebysingleRoom')
		{
			cubeGeometry = new THREE.BoxGeometry( 49, 50, 49,1,1,1 );// moving to roomObj
		}
		else if(domID == 'onebytwoRoom')
		{
			cubeGeometry = new THREE.BoxGeometry( 49, 50, 99,1,1,2 );// moving to roomObj
		}
		else if(domID == 'onebytripleRoom')
		{
			cubeGeometry = new THREE.BoxGeometry( 49, 50, 149,1,1,3 );// moving to roomObj
		}
		else if(domID == 'twobytwoRoom')
		{
			cubeGeometry = new THREE.BoxGeometry( 99, 50, 99,2,1,2 );// moving to roomObj

		}
		else if(domID == 'twobythreeRoom')
		{
			cubeGeometry = new THREE.BoxGeometry( 99, 50, 149,2,1,3 );// moving to roomObj

		}
		else if(domID == 'twobyfourRoom')
		{
			cubeGeometry = new THREE.BoxGeometry( 99, 50, 199,2,1,4 );// moving to roomObj

		}

		return cubeGeometry;
	
	},
	// #  Gets our material based on abbreviation type
	getMaterial: function(domID,space)
	{
		var colorNormal;
		// #  Lets check to see if we have any colors for this space
		if(!space)
		{
			colorNormal = this.colorNormal;
		}
		else
		{
			// #  Set corresponding state
			colorNormal = space.color_hex_code;
		}
		var cubeMaterial;
		
		if(domID == 'onebysingleRoom')
		{
			cubeMaterial = new THREE.MeshLambertMaterial( { color: colorNormal, overdraw: 1 } ); // moving to roomObj
		}
		else if(domID == 'onebytwoRoom')
		{
			cubeMaterial = new THREE.MeshLambertMaterial( { color: colorNormal, overdraw: 1 } ); // moving to roomObj
		}
		else if(domID == 'onebytripleRoom')
		{
			cubeMaterial = new THREE.MeshLambertMaterial( { color: colorNormal,overdraw: 1 } ); // moving to roomObj
		}
		else if(domID == 'twobytwoRoom')
		{
			cubeMaterial = new THREE.MeshLambertMaterial( { color: colorNormal,overdraw: 1 } ); // moving to roomObj

		}
		else if(domID == 'twobythreeRoom')
		{
			cubeMaterial = new THREE.MeshLambertMaterial( { color: colorNormal,overdraw: 1 } ); // moving to roomObj

		}
		else if(domID == 'twobyfourRoom')
		{
			cubeMaterial = new THREE.MeshLambertMaterial( { color: colorNormal,overdraw: 1 } ); // moving to roomObj

		}

		return cubeMaterial;
	},
	// #  Gets our room id based on abbreviation type
	getRoomID: function(domID)
	{
		var roomID;
		
		if(domID == 'onebysingleRoom')
		{
			roomID = 1
		}
		else if(domID == 'onebytwoRoom')
		{
			roomID = 2
		}
		else if(domID == 'onebytripleRoom')
		{
			roomID = 3
		}
		else if(domID == 'twobytwoRoom')
		{
			roomID = 4

		}
		else if(domID == 'twobythreeRoom')
		{
			roomID = 4

		}
		else if(domID == 'twobyfourRoom')
		{
			roomID = 6

		}
		else if(domID == 'onebyonehall')
		{
			roomID = 7
		
		}
		else if(domID == 'twobytwohall')
		{
			roomID = 8
		}

		return roomID;
	},
	getDivideScalar : function(domID)
	{
		var divideScalar;
		
		if(domID == 'onebysingleRoom')
		{
			divideScalar = 50; 
		}
		else if(domID == 'onebytwoRoom')
		{
			divideScalar = 50; 
		}
		else if(domID == 'onebytripleRoom')
		{
			divideScalar = 50; 
		}
		else if(domID == 'twobytwoRoom')
		{
			divideScalar = 50; 

		}
		else if(domID == 'twobythreeRoom')
		{
			divideScalar = 50; 

		}
		else if(domID == 'twobyfourRoom')
		{
			divideScalar = 50; 

		}

		return divideScalar;
	},
	getMultiplyScalar: function(domID)
	{
		var multiplyScalar;
		
		if(domID == 'onebysingleRoom')
		{
			multiplyScalar = 50; 
		}
		else if(domID == 'onebytwoRoom')
		{
			multiplyScalar = 50; 
		}
		else if(domID == 'onebytripleRoom')
		{
			multiplyScalar = 50; 
		}
		else if(domID == 'twobytwoRoom')
		{
			multiplyScalar = 50; 

		}
		else if(domID == 'twobythreeRoom')
		{
			multiplyScalar = 50; 

		}
		else if(domID == 'twobyfourRoom')
		{
			multiplyScalar = 50; 

		}

		return multiplyScalar;
	},
	getAddScalar: function(domID)
	{
		var addScalar;
		
		if(domID == 'onebysingleRoom')
		{
			addScalar = 25; 
		}
		else if(domID == 'onebytwoRoom')
		{
			addScalar = 25; 
		}
		else if(domID == 'onebytripleRoom')
		{
			addScalar = 25; 
		}
		else if(domID == 'twobytwoRoom')
		{
			addScalar = 25; 

		}
		else if(domID == 'twobythreeRoom')
		{
			addScalar = 25; 

		}
		else if(domID == 'twobyfourRoom')
		{
			addScalar = 25; 

		}

		return addScalar;
	},
	getAdditionalZ: function(domID)
	{
		var additionalZ;
		
		if(domID == 'onebysingleRoom')
		{
			additionalZ = 0; 
		}
		else if(domID == 'onebytwoRoom')
		{
			additionalZ = 0; 
		}
		else if(domID == 'onebytripleRoom')
		{
			additionalZ = 0; 
		}
		else if(domID == 'twobytwoRoom')
		{
			additionalZ = 25; 

		}
		else if(domID == 'twobythreeRoom')
		{
			additionalZ = 0; 

		}
		else if(domID == 'twobyfourRoom')
		{
			additionalZ = 25; 

		}

		return additionalZ;
	},
	getAdditionalX: function(domID)
	{
		var additionalX;
		
		if(domID == 'onebysingleRoom')
		{
			additionalX = 0; 
		}
		else if(domID == 'onebytwoRoom')
		{
			additionalX = 0; 
		}
		else if(domID == 'onebytripleRoom')
		{
			additionalX = 0; 
		}
		else if(domID == 'twobytwoRoom')
		{
			additionalX = 25; 

		}
		else if(domID == 'twobythreeRoom')
		{
			additionalX = 25; 

		}
		else if(domID == 'twobyfourRoom')
		{
			additionalX = 25; 

		}

		return additionalX;
	},
	// #  Used to load colors from our server
	loadColors: function() {
		// Call server for our data
		// #  Localize this instance for use on success
		var self = this;

        colorCoding.getGlobalColors(function(colors){
            if(colors === undefined) {
                // #  Default colors
                var colorNormal = 0x529487;
                var colorHover = 0x31658b;
                var colorTmpHover = 0xEAEAEA;
                var colorRemove = 0xE23434;
                                    
                self.colorNormal = colorNormal;
                self.colorHover = colorHover;
                self.colorTmpHover = colorTmpHover;
                self.colorRemove = colorRemove;
            }

            for(var i = 0; i < colors.length; i++)
			{
                var color = colors[i].data;

                switch(color.color_state) {
                    case "0": {
                        self.colorNormal = color.color_hex_code;
                        break;
                    }
                    case "1": {
                        self.colorHover = color.color_hex_code;
                        break;
                    }
                    case "2": {
                        self.colorTmpHover = color.color_hex_code;
                        break;
                    }
                    case "3": {
                        self.colorRemove = color.color_hex_code;
                        break;
                    }
                    default: {
                        break;
                    }
                }
            }
        });
		// prepare our data to be sent
		/*var url = "app/server/service.php";
		var params = {'action': 'getGlobalColors', 'module' : 'ColorCoding'};
		var object = this;
		// #  Send to server object for processing
		var data = this.server.getData(url,params,false);
		// #  Listen to our data
		data
		.done(function(response){
			// #  Validate response
			if(response.status == 1 || response.status == 2)
			{
			}
			else
			{
				// #  No global colors found
				if('error' in response.data)
				{
					// #  Default colors
					var colorNormal = 0x529487;
					var colorHover = 0x31658b;
					var colorTmpHover = 0xEAEAEA;
					var colorRemove = 0xE23434;
										
					self.colorNormal = colorNormal;
					self.colorHover = colorHover;
					self.colorTmpHover = colorTmpHover;
					self.colorRemove = colorRemove;
				}
				else
				{
					var colors = response.data.globalColors;

					self.colorNormal = colors.colorNormal;
					self.colorHover = colors.colorHover;
					self.colorTmpHover = colors.colorTmpHover;
					self.colorRemove = colors.colorRemove;
				}
	
			}
		})
		.fail(function(e){
			console.log(e);
		});*/
	}

});

export let roomRenderer = new RoomRenderer();


// WEBPACK FOOTER //
// app/core/graphic_engine/controllers/RoomRenderer.js